import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-container">
      <div className="about-card">
        <h1 className="about-title">sobre mí ★</h1>
        
        <div className="about-content">
          <p>
            ¡Hola! Soy <strong>panchi</strong>, estudiante de periodismo apasionada por 
            la moda, la música y las noticias de actualidad.
          </p>
          
          <p>
            Este es mi espacio personal donde comparto mis opiniones, descubrimientos 
            musicales, análisis de noticias y todo lo relacionado con estilo y cultura pop.
          </p>

          <div className="about-section">
            <h2>✨ lo que encontrarás aquí:</h2>
            <ul>
              <li><strong>actualidad:</strong> análisis y opiniones sobre noticias relevantes</li>
              <li><strong>moda:</strong> tendencias, outfit inspo y comentarios de estilo</li>
              <li><strong>música:</strong> reviews, descubrimientos y recomendaciones</li>
            </ul>
          </div>

          <div className="about-section">
            <h2>💭 sobre este blog:</h2>
            <p>
              Creado con mucho amor como un proyecto personal. Un espacio para expresarme 
              libremente y conectar con personas que comparten mis intereses.
            </p>
          </div>
          
            <div className="about-links">
            <a href="mailto:tu@email.com" className="social-link">✉️ contacto</a>
            <a href="https://open.spotify.com/" target="_blank" rel="noopener noreferrer" className="social-link">🎵 playlist</a>
            <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer" className="social-link">📸 instagram</a>
            </div>
        </div>
      </div>
    </div>
  );
};

export default About;
